import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { isEmptyObject } from '../../lib/utils';

type UserData = {
  name: string;
  selected_schedule: string;
  checked_in: boolean
};

const AttendancePage = () => {
  const { id } = useParams();

  const [userData, setUserData] = useState<UserData | null>(null);

  const fetchParticipantDetails = useCallback(async () => {
    const response = await fetch(`https://admin.seremony.id/api/seremony-events/participant/${id}`)
    // const response = await fetch(`http://localhost:3001/seremony-events/participant/${id}`);
    const resData = await response.json();
    const { data } = resData;
    setUserData(data);
  }, [id]);


  useEffect(() => {
    fetchParticipantDetails();

    return () => { }
  }, [fetchParticipantDetails]);


  return (
    <main className='relative text-black'>
      <div className='w-[60px] h-[120px] bg-secondary-green absolute -left-4 -bottom-0 scale-50 lg:scale-100 z-10' />
      <div className='w-[60px] h-[120px] bg-secondary-green absolute -right-4 -top-8 scale-50 lg:scale-100 z-10' />
      <div className='w-[30px] h-[340px] bg-secondary-red absolute right-0 bottom-0 z-[1]' />
      <div className='h-[100vh] bg-primary-cultures relative p-5 flex flex-col'>
        <img
          src={`/images/logo/logo-text-black-color.svg`}
          alt=""
          className='h-10 w-auto mt-5'
        />
        <div className='flex items-center justify-center flex-col z-[10] mt-10'>
          <img src="https://admin.seremony.id/api/images/events/exclusive-wedding-experience-session.jpeg" alt="" className='z-[10] lg:h-72 lg:w-auto mt-5 md:mt-10' />
        </div>

        {userData ?
          <div className='my-5 z-[10] text-black pt-4'>
            <h1 className='text-xl text-center'>Welcome</h1>
            <div className='mt-5 rounded-xl py-4 bg-main-orange'>
              <h2 className='text-3xl w-full text-white font-semibold text-center'>{userData.name}</h2>
            </div>
            <p className='text-center mt-12'>We are so excited to get started and share what we have planned for you. Our Team will be pleasure to assist you during this event.</p>
          </div>
          : <div className='my-20 z-[10]'>
            <h1 className='text-lg text-center text-black'>Data pengunjung <br /> tidak ditemukan</h1>
          </div>}
      </div>
    </main>
  )
}

export default AttendancePage